import { useState, useEffect } from 'react';
import 'intersection-observer';

const useOnScreen = (ref, options) => {
  // State and setter for storing whether element is visible
  const [isIntersecting, setIntersecting] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      // Update our state when observer callback fires
      setIntersecting(entry.isIntersecting);
    }, options);
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [ref.current]); // Empty array ensures that effect is only run on mount and unmount
  return isIntersecting;
};
export default useOnScreen;
